import { CheckCircle2 } from 'lucide-react';

export default function ConfirmationModal({ 
  show, 
  formData, 
  onConfirm, 
  onCancel 
}) {
  if (!show) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-black bg-opacity-50">
      <div className="overflow-hidden mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl">
        <div className="p-6">
          <div className="mb-6 text-center">
            <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-emerald-100 rounded-full">
              <CheckCircle2 size={32} className="text-emerald-600" />
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-900">Confirm Payment Method</h3>
            <p className="text-gray-600">Please review your details before saving</p>
          </div>

          <div className="p-4 mb-6 bg-gray-50 rounded-lg">
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">Provider:</span>
                <span className="font-medium text-gray-900">{formData.providerName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Phone Number:</span>
                <span className="font-medium text-gray-900">{formData.phoneNumber}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Wallet Name:</span>
                <span className="font-medium text-gray-900">{formData.walletName}</span>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 rounded-lg transition-colors hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 py-3 font-medium text-white bg-emerald-600 rounded-lg transition-colors hover:bg-emerald-700"
            >
              Confirm & Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
